import { IconSubtitles } from "@tine/designsystem-icons/sharp";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { productImageUrl } from "../common/imageUtils";
import type { FlyingProductOrItemAnimationState } from "../common/types/productTypes";
import uiStore from "../stores/uiStore";

type FlyingProductOrItemProps = {
   plane: FlyingProductOrItemAnimationState;
};

const FlyingProductOrItem = ({ plane }: FlyingProductOrItemProps) => {
   useEffect(() => {
      setTimeout(() => {
         uiStore.takeOff(plane.animationId, plane.landingPadId);
      }, 200);
   }, []);

   if (plane.landingPadId === "advent-calendar-sticky") {
      return (
         <IconSubtitles
            height={60}
            width={60}
            className="p-1 shadow-lg dsp-flyer bg-background-default text-christmasButton"
            style={{
               top: plane.y,
               left: plane.x,
               height: plane.height
            }}
         />
      );
   }

   if (!plane.sku) {
      return null;
   }

   return (
      <img
         alt="Produkt på vei til handlekurven"
         src={productImageUrl(plane.sku, plane.sourceWidth)}
         className="dsp-flyer"
         style={{
            top: plane.y,
            left: plane.x,
            height: plane.height
         }}
      />
   );
};

export default observer(FlyingProductOrItem);
